<template>
  <ChapterComponent class="chapter--header-right" :opened="opened" :number="5" illustration="5/1.jpg">
    <div class="chapter__header-texts" slot="header_texts">
      <div class="chapter__number">V</div>
      <div class="chapter__author">Автор Тихон Шаров</div>
      <div class="chapter__headline">Завтра в три</div>
      <div class="chapter__inner">
        <div class="chapter__description">
          <div class="chapter__description__inner">
            Да чтоб тебя — в пятый раз запорол кикфлип! Дэн со всей силы запустил доской в перила рампы. И тут же, забыв об ушибленном колене, подбежал к одиноко лежащему скейтборду, начал придирчиво его рассматривать<span class="chapter__description__not-opened-text">...</span><span class="chapter__description__opened-text">. Еще не хватало испортить кастомную pro-модель — главное сокровище, без которого все потеряет смысл.</span>
          </div>
        </div>
        <div class="chapter__mobile-illustration" :style="{backgroundImage: `url(${require(`../../assets/illustrations/5/1.jpg`)})`}"></div>
        <div class="chapter__buttons">
          <a class="button" v-if="!opened" @click="opened = true" v-ga.click="$ga.commands.click.bind(this,'internal', 'click', 'open_chapter_5')">Открыть главу</a>
          <div v-else class="chapter__read-more">
            <div class="chapter__read-more__text">Читать далее</div>
            <svg  class="chapter__read-more__arrow" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 110.2" style="enable-background:new 0 0 26 110.2;" xml:space="preserve">>
              <path class="st0" d="M21.9,65c-2,5-4,10.1-6,15.1C15,55.7,14.2,31.2,13.4,6.8c0-1.2-4.7-0.8-4.6,0.5c0.8,26.5,1.7,53,2.7,79.6 c-2-5.3-4.1-10.7-6.1-16c-0.5-1.3-5-0.5-4.6,0.5L12,102.1c0.4,1,3.3,0.9,4.3,0.1c0.3-0.2,0.6-0.4,0.7-0.6 c3.2-12.2,6.3-24.4,9.5-36.6C26.8,63.6,22.3,63.9,21.9,65"/>
            </svg>
          </div>
          <Listen :chapter="5" :opened="opened" />
        </div>
      </div>
    </div>
    <div slot="main" class="chapter__main" v-if="opened">
      <div class="chapter__texts">
        <Paragraph class="chapter__paragraph chapter__paragraph--1">
          <div class="person">
            <div class="person__inner">
              <img class="person__photo" src="@/assets/illustrations/5/photo.png"/>
              <div class="person__name">Илья Инкин</div>
              <div class="person__age">22 года</div>
              <div class="person__info">
                Студент архитектурного колледжа
              </div>
              <div class="person__location">
                Корпус Adagio, 17-й этаж
              </div>
              <MapToggle/>
            </div>
          </div>
          <p>Теплый августовский день клонился к закату, и площадка почти полностью обезлюдела. Мимо пробежал трусцой <router-link @click.native="$ga.event('internal','click', 'open_chapter_2')" to="/chapters/2" class="chapter__link">Илья</router-link> — старшая сестра Дэна иногда обедает с ним в кафе у фонтана. Нормальный чувак, только чересчур серьезный. Хотя каким еще может быть будущий архитектор? Дэн, прихрамывая, побрел к ближайшей скамейке. И только присев, заметил мужчину в прикольной кожаной куртке, стоявшего у фонарного столба. Поймав взгляд Дэна, незнакомец приветливо кивнул. Получается, он видел жесткий фейл на рампе. Ну и ладно — с утра уже было понятно, что сегодня подвигов не будет. Домой идти совсем не хотелось после вчерашнего скандала. Отец вернулся с работы злой как черт и все припомнил — деньги, которые уходят на обувь и запчасти, плохие оценки, «тусовку бездельников». Конечно, он и раньше напрягался из-за его увлечения, но вчера разразилась настоящая катастрофа. Даже мама прослезилась и попросила Дэна перестать торчать в скейт-парке с утра до вечера. На самом-то деле ее пугают возможные травмы: «шею сломаешь», «ногу свернешь» — вся эта ботва. Ведь были уже и вывихи, и гематомы. Сам Дэн не стал оправдываться, молча все выслушал и гордо удалился в свою комнату. За последние два года парк и вправду стал местом, где ему всегда комфортно. Постепенно очередное хобби превратилось в стиль жизни. И сейчас основной целью была поездка на соревнования в Чехию… Вот только уже неделю Дэна преследовали неудачи — ну никак не удавалось собраться, чтобы выдать нужный результат. И мрачная мысль скреблась где-то на задворках души — вдруг он переоценил свои силы и тратит время впустую?</p>
          <Listen :chapter="5" class="listen--mobile-only" />
        </Paragraph>
        <Paragraph class="chapter__paragraph chapter__paragraph--2">
          <p>А дальше началось что-то совсем невообразимое. Мужик с легкостью вскочил на борд, подъехал к рампе и стал творить чудеса. Он выполнил злополучный кикфлип, потом олли, бэксайд-шовит и еще несколько убойных трюков, подвластных только скейтерской элите. Вернувшись к скамейке, загадочный райдер ловко подцепил доску и вручил ее остолбеневшему хозяину.</p>
          <p>— Хороший борд, парень. Да и рампа толковая. Если б в мое время были такие площадки…</p>
          <p>— Да, парк у нас классный… А вы… профессиональный скейтер?</p>
          <p>— Теперь уже на заслуженном отдыхе. Лет десять назад понял, что достиг потолка и ушел в бизнес. Но, если честно, доска — это навсегда.</p>
          <p>— А как ваши видео в сети найти?</p>
          <p>— Зачем нам сеть, если мы соседи? Думаю, несколько уроков тебе не помешают. Стойку держишь, а выдержки не хватает. Но это поправимо.</p>
          <p>— Серьезно? Вы могли бы со мной позаниматься?</p>
          <p>— Давай так — завтра в три на этом месте. Пора и мне смахнуть пыль с борда. Закрепим азы, потом перейдем к сложным прыжкам. Не опаздывай!</p>
          <p>И только когда новый учитель пружинистой походкой удалился в направлении комплекса, Дэн понял, что так и не узнал его имени. Но это не беда — вот как бы теперь дождаться завтрашнего дня?</p>
        </Paragraph>
      </div>
      <div class="plan">
        <div class="plan__header">
          Место здоровья
        </div>
        <div class="plan__main">
          <div class="plan__background"></div>
          <img src="@/assets/illustrations/5/2.jpg" class="plan__photo"/>
          <div class="plan__description">
            <div class="plan__description__text">«Фили Сити» заботится о том, чтобы у вас были все возможности для занятий спортом и ЗОЖ: здесь есть воркаут-зона, рампа для скейтеров и баскетбольная площадка. Свои достижения можно отслеживать с помощью мобильного приложения, а также есть возможность записаться на индивидуальную тренировку с инструктором.</div>
            <a target="_blank" href="https://filicity.ru/?utm_source=article&utm_campaign=june19&utm_medium=banner&utm_content=5" class="button"  v-ga.click="$ga.commands.click.bind(this,'external', 'click', 'chapter_5_podrobnee')">Подробнее</a>
          </div>
       </div>
      </div>
      <div class="chapter__next">
        <div class="chapter__number">VI</div>
        <div class="chapter__headline">2 + 2 = ?</div>
        <div class="chapter__next__button">
          <router-link class="button" to="/chapters/6"   v-ga.click="$ga.commands.click.bind(this,'internal', 'click', 'bottom_open_chapter_6')">Открыть главу</router-link>
        </div>
      </div>
    </div>
  </ChapterComponent>
</template>
<style lang="stylus" scoped>
  @import "~@/assets/styles/sizes.styl";
  .chapter
    &__next
      padding vw(60, $desktop) 0 vw(80, $desktop)
    &__paragraph
      &--1
        padding-top vw(40, $desktop)
        margin-left vw(200, $desktop)
        width vw(500, $desktop)
        margin-bottom vw(70, $desktop)
        .person
          top vw(-30, $desktop)
          right vw(-270, $desktop)
          &__photo
            width vw(110, $desktop)
      &--2
        margin-left auto
        margin-right vw(160, $desktop)
        width vw(560, $desktop)
        margin-top vw(120, $desktop)
        margin-bottom vw(70, $desktop)
  .plan__description
    top vw(180, $desktop)
  .plan__mrgroup-logo
    bottom 0
    left: vw(50, $desktop)
    position: absolute;
    img
      height vw(20, $desktop)
      +mobile()
        height: vw(20, $mobile)
    +mobile()
        bottom: vw(-30, $mobile)
        left: vw(20, $mobile)
</style>
<script>
    import ChapterComponent from '@/components/ChapterComponent';
    import Paragraph from '@/components/Paragraph';
    import Listen from '@/components/Listen';
    import MapToggle from '@/components/MapToggle';
    export default {
        components: {
            Paragraph,
            Listen,
            MapToggle,
            ChapterComponent
        },
      data() {
          return {
              opened: !!this.$route.query.opened || false
          }
      }
  }
</script>